module.exports = __webpack_public_path__ + "img/sdyl.b4d770c8.png";